var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48095493"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 19,
    cy: 19,
    r: 18,
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 48095496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9742 13.3041L12.9604 11.5425L6.0004 23.7471L9.01419 25.5087L15.9742 13.3041Z",
    stroke: "black",
    strokeWidth: 1.352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4152 9.58719L16.4198 10.1744C16.9745 10.4986 17.1647 11.2171 16.8444 11.7786L15.9744 13.3042L12.9606 11.5426L13.8306 10.0171C14.1509 9.45549 14.8606 9.26298 15.4152 9.58719Z",
    stroke: "black",
    strokeWidth: 1.352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.15576 23.5515L6.21293 26.9749L9.1693 25.3131",
    stroke: "black",
    strokeWidth: 0.901331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9604 26.9849C15.6517 27.6032 18.6544 27.2022 20.9802 25.912C21.9555 25.371 23.0857 24.6471 24.1645 25.0271C25.0096 25.3248 25.351 26.1704 26.0404 26.6762C26.6883 27.1527 27.6138 27.2936 28.4722 27.2139C29.3307 27.1342 30.6514 26.6821 31.2314 26.0949",
    stroke: "black",
    strokeWidth: 1.80266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b22aceab654004b0c5eb679f438eece9.svg";
export { ForwardRef as ReactComponent };